export * from './InfoPage';
export * from '../../../slotV2/modules/infopage/InfoPageEvents';
export * from './PayTablesGenerator';
